import { FieldPath, FieldValues, UseFormReturn } from 'react-hook-form';
import {
  DateTimePicker,
  DateTimePickerProps,
} from 'components/atoms/DateTimePicker';

type TaskEndDateTimePickerProps<TFieldValues extends FieldValues> = Pick<
  DateTimePickerProps<TFieldValues>,
  'inputProps'
> & {
  name: FieldPath<TFieldValues>;
  control: UseFormReturn<TFieldValues>['control'];
  startDateTimeProps: StartDateTimeProps<TFieldValues>;
};

type StartDateTimeProps<TFieldValues extends FieldValues> = {
  name: FieldPath<TFieldValues>;
  getValues: UseFormReturn<TFieldValues>['getValues'];
};

const getErrorMessage = <TFieldValues extends FieldValues>(
  { name, getValues }: StartDateTimeProps<TFieldValues>,
  endsAt: Date,
) => {
  const startsAt = getValues(name) as Date;
  if (startsAt == null || endsAt == null) return true;
  if (endsAt.getTime() < startsAt.getTime()) {
    return '「タスク開始日」以前の日時は設定できません。';
  }
  if (endsAt.getTime() === startsAt.getTime()) {
    return '「タスク開始日」と同じ日時は設定できません。';
  }

  return true;
};

/**
 * リリースタスク作成時の日時入力項目です。
 */
export const TaskEndDateTimePicker = <TFieldValues extends FieldValues>({
  name,
  control,
  inputProps,
  startDateTimeProps,
}: TaskEndDateTimePickerProps<TFieldValues>) => (
  <DateTimePicker
    datePickerProps={{
      minDate: new Date(),
      timeIntervals: 60,
    }}
    controllerProps={{
      control,
      name,
      rules: {
        validate: (date) => getErrorMessage({ ...startDateTimeProps }, date),
        required: '必須項目です。',
      },
    }}
    inputProps={inputProps}
  />
);
